import { toUpper, get } from "lodash"
import { FACTOR_SENSITIVITY_LOOKBACK_DAYS } from "helpers/factorSensitivity"
import { percentageFormatter } from "helpers/formatters/numbers"
import { generateQueryKey } from "connected-components/dashboard/helpers/query-key"

const QUERY = `query MultiDateFactorSensitivityQuery($modelId: String!, $positionSet: PositionSetInput!, $base: [PositionSetInput], $from: Date!, $to: Date!, $factorSensitivityType: FactorSensitivityType!, $stdDev: PositiveFloat, $days: PositiveInt, $horizon: FactorSensitivityTimeHorizon!) {
  model(id: $modelId) {
    simulation(positionSet: $positionSet, base: $base, from: $from, to: $to, interval: AUTO) {
      factorSensitivity(
        type: $factorSensitivityType
        horizon: $horizon
        stdDev: $stdDev
        days: $days
      ) {
        date
        factors {
          id
          name
          category
          sensitivity
        }
      }
    }
  }
}`

export function createFactorSensitivityMultiDateQuery(modelId, positionSet, base, from, to, factorSensitivityType) {
  return {
    key: generateQueryKey("factorSensitivity.multiDate", { factorSensitivityType, modelId, positionSet, base, from, to }),
    query: QUERY,
    variables: {
      modelId,
      positionSet,
      base,
      from,
      to,
      horizon: "MONTHLY",
      days: factorSensitivityType === "historical" ? FACTOR_SENSITIVITY_LOOKBACK_DAYS : undefined,
      factorSensitivityType: toUpper(factorSensitivityType),
    },
    select: (graphqlResult) => {
      const factorSensitivity = get(graphqlResult, "data.model.simulation.factorSensitivity", [])
      return ({
        values: {
          formatter: percentageFormatter,
          dates: factorSensitivity.map(({ date, ...dateData }) => {
            const factors = dateData.factors.reduce((acc, { id, sensitivity }) => {
              acc[id] = sensitivity
              return acc
            }, {})

            return {
              date,
              ...factors,
            }
          }),
        },
      })
    },
  }
}
